/**
 * Terms & Conditions Page
 */

import React from 'react';
import { FileText, AlertCircle } from 'lucide-react';

const TERMS_SECTIONS = [
  {
    title: 'مقدمة',
    content: 'مرحباً بك في منصة "خالتي هيلة" للتعارف بهدف الزواج. باستخدامك لهذه المنصة، فإنك توافق على الالتزام بهذه الشروط والأحكام. يرجى قراءتها بعناية قبل استخدام المنصة.'
  },
  {
    title: 'الأهلية للاستخدام',
    content: '• يجب أن يكون عمرك 18 سنة أو أكثر لاستخدام المنصة.\n• يجب أن تكون سعودي/سعودية الجنسية.\n• يجب أن تكون نيتك صادقة في البحث عن شريك حياة بهدف الزواج.\n• يجب أن تكون غير متزوج/متزوجة حالياً (أو مطلق/مطلقة أو أرمل/أرملة).'
  },
  {
    title: 'إنشاء الحساب',
    content: '• يجب تقديم معلومات صحيحة ودقيقة عند التسجيل.\n• أنت مسؤول عن الحفاظ على سرية حسابك وكلمة المرور.\n• يجب عدم مشاركة حسابك مع أي شخص آخر.\n• يحق لنا تعليق أو إلغاء أي حساب يتضمن معلومات كاذبة.'
  },
  {
    title: 'قواعد السلوك',
    content: '• التعامل باحترام مع جميع المستخدمين.\n• عدم إرسال رسائل مسيئة أو مزعجة.\n• عدم مشاركة محتوى غير لائق.\n• عدم انتحال شخصية أي شخص آخر.\n• عدم استخدام المنصة لأغراض غير مشروعة.\n• الإبلاغ عن أي سلوك مشبوه أو مخالف.'
  },
  {
    title: 'الخصوصية',
    content: '• نحترم خصوصيتك ونحمي بياناتك وفقاً لسياسة الخصوصية.\n• لا نشارك معلوماتك الشخصية مع أطراف ثالثة.\n• بياناتك الحساسة مشفرة بأعلى معايير الأمان.\n• يحق لك طلب حذف بياناتك في أي وقت.'
  },
  {
    title: 'المحادثات',
    content: '• مدة المحادثة الأساسية 7 أيام قابلة للتمديد.\n• يحق لأي طرف الانسحاب من المحادثة في أي وقت.\n• يُمنع مشاركة معلومات التواصل في أول 3 أيام.\n• المحادثات مشفرة ولا نطّلع على محتواها.'
  },
  {
    title: 'إخلاء المسؤولية',
    content: '• المنصة تهدف للتعارف فقط ولا تضمن نتائج محددة.\n• لا نتحمل مسؤولية أي علاقة تنشأ خارج المنصة.\n• نوصي بالتحقق من هوية الطرف الآخر قبل أي خطوة جدية.\n• يجب إشراك الأهل قبل اتخاذ أي قرار زواج.'
  },
  {
    title: 'القانون المعمول به',
    content: 'تخضع هذه الشروط لقوانين المملكة العربية السعودية، وأي نزاع ينشأ يتم حله وفقاً للأنظمة السعودية المعمول بها.'
  }
];

export default function Terms() {
  return (
    <div className="pt-20">
      {/* Hero */}
      <section className="bg-gradient-to-br from-gray-50 to-rose-50 py-16 md:py-24">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <FileText className="w-16 h-16 text-gray-600 mx-auto mb-4" />
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            الشروط والأحكام
          </h1>
          <p className="text-lg text-gray-600">
            آخر تحديث: يناير 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          {/* Notice */}
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-8 flex items-start gap-3">
            <AlertCircle className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" />
            <p className="text-amber-800 text-sm">
              باستخدامك لمنصة "خالتي هيلة"، فإنك توافق على هذه الشروط والأحكام.
            </p>
          </div>

          {/* Terms Sections */}
          <div className="space-y-8">
            {TERMS_SECTIONS.map((section, index) => (
              <div key={index} className="border-b border-gray-100 pb-8 last:border-0">
                <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <span className="w-8 h-8 bg-rose-100 text-rose-600 rounded-lg flex items-center justify-center text-sm font-bold">
                    {index + 1}
                  </span>
                  {section.title}
                </h2>
                <div className="text-gray-600 leading-relaxed whitespace-pre-line pr-10">
                  {section.content}
                </div>
              </div>
            ))}
          </div>

          {/* Contact */}
          <div className="mt-12 bg-gray-50 rounded-xl p-6 text-center">
            <p className="text-gray-600 mb-2">للأسئلة، تواصل معنا:</p>
            <a href="mailto:support@khaltihaila.com" className="text-rose-600 font-medium hover:underline">
              support@khaltihaila.com
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
